import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('kt_token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// AuthContext registers its refresh function here so the response interceptor
// can call it without importing React state directly.
let authRefresher = null;
export const setAuthRefresher = (fn) => { authRefresher = fn; };

api.interceptors.response.use(
  (response) => response,
  async (error) => {
    const original = error.config;
    const status = error.response?.status;

    if (
      status === 401 &&
      original &&
      !original._retry &&
      !original._skipAuthRefresh &&
      authRefresher &&
      localStorage.getItem('kt_refresh')
    ) {
      original._retry = true;
      try {
        const newAccessToken = await authRefresher();
        original.headers = original.headers || {};
        original.headers.Authorization = `Bearer ${newAccessToken}`;
        return api(original);
      } catch (refreshErr) {
        // Refresh failed — fall through to reject the original error so callers see 401.
      }
    }

    return Promise.reject(error);
  },
);

export default api;
